<template>
  <div id="ContractCpiRateConfigTabView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <template v-if="addRate == true">
      <form
        autocomplete="off"
        class="form-horizontal basic-form-container add-user-form-title"
        id="ContractAssetDetailForm"
      >
        <div class="alert-contract field-error hide"></div>
        <div class="row">
          <div class="col-md-3 form-group">
            <label class="control-label require" for="cpi_increase_percent"
              >CPI:</label
            >
          </div>
          <div class="col-md-3 form-group">
            <label class="control-label require" for="rate_increase_percent"
              >Rate:</label
            >
          </div>
          <div class="col-md-4 form-group">
            <label class="control-label require" for="rate_increase_limit"
              >Limit:</label
            >
          </div>
        </div>
        <div class="row" v-for="(cpi, index) in cpiratesArr" v-bind:key="index">
          <input
            type="hidden"
            class="form-control"
            v-model="cpi.id"
            placeholder=""
            name="rate_id"
          />
          <div class="col-md-3 form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">%</div>
              </div>
              <input
                type="text"
                class="form-control text-right"
                v-model="cpi.cpi_increase_percent"
                id="cpi_increase_percent"
                placeholder="CPI Percent"
                name="cpi_increase_percent"
                aria-describedby="basic-addon3"
              />
            </div>
            <div class="field-error">{{ cpi.cpi_increase_error_msg }}</div>
          </div>
          <div class="col-md-3 form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">%</div>
              </div>
              <input
                type="text"
                class="form-control text-right"
                v-model="cpi.rate_increase_percent"
                id="rate_increase_percent"
                placeholder="Rate Percent"
                name="rate_increase_percent"
                aria-describedby="basic-addon3"
              />
            </div>
            <div class="field-error">{{ cpi.rate_increase_error_msg }}</div>
          </div>
          <div class="col-md-3 form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">%</div>
              </div>
              <input
                type="text"
                class="form-control text-right"
                v-model="cpi.limit_percent"
                id="limit_percent"
                placeholder="Limit Percent"
                name="limit_percent"
                aria-describedby="basic-addon3"
              />
            </div>
            <div class="field-error">{{ cpi.limit_percent_error_msg }}</div>
          </div>
          <div class="col-md-3 form-group mt-2">
            <template
              v-if="
                cpiratesArr.length != 1 &&
                (cpi.id == 0 || cpi.id == '' || cpi.id == null)
              "
            >
              <a
                href="javascript:void(0)"
                class="fp-remove"
                v-on:click.prevent="removeLine(index, cpi.id)"
              ></a>
            </template>
            <label>&nbsp;&nbsp;</label>
            <template>
              <a
                href="javascript:void(0)"
                class="fp-plus"
                v-if="
                  index + 1 === cpiratesArr.length && cpiratesArr.length < 5
                "
                v-on:click.prevent="addLine($event, index)"
              ></a>
            </template>
          </div>
        </div>
        <div class="btn-groups">
          <button
            type="button"
            title="Edit Asset"
            class="btn btn-primary"
            v-on:click="createCPiRate()"
          >
            <i class="fp-save"> </i> Save
          </button>
          <button
            type="button"
            title="Edit Asset"
            class="btn btn-tertiary"
            v-on:click="backCPiRateList()"
          >
            <i class="fp-close"> </i> Cancel
          </button>
        </div>
      </form>
    </template>
    <template v-else>
      <div v-if="canAddCpiRate" class="btn-groups text-right mb-4">
        <button
          title="Add CPI Rate"
          v-if="foundRate == false"
          class="btn btn-primary"
          v-on:click="loadContractCPiRate('create')"
        >
          <i class="fp-add"></i> Add
        </button>
        <button
          title="Add CPI Rate"
          class="btn btn-primary"
          v-on:click="loadContractCPiRate('update')"
          v-else
        >
          <i class="fp-edit-icon"> </i> Update
        </button>
      </div>
      <h5 v-if="foundRate == false">No CPI Rate Data Found...</h5>
      <div class="table-responsive-sm">
        <table
          aria-describedby="table"
          id=""
          class="table table-sm table-bordered font-1"
          v-if="foundRate == true"
        >
          <thead>
            <tr class="table-primary">
              <th>Section</th>
              <th>CPI(%)</th>
              <th>Rate(%)</th>
              <th>Limit(%)</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="cpiData && cpiData.length > 0">
              <template v-for="(record, index) in cpiData">
                <tr v-bind:key="'recordRow' + index">
                  <td>
                    {{
                      record.cpi_increase_percent ==
                      record.rate_increase_percent
                        ? "VARIABLE"
                        : "FIXED"
                    }}
                  </td>
                  <td>{{ record.cpi_increase_percent }}</td>
                  <td>{{ record.rate_increase_percent }}</td>
                  <td>{{ record.limit_percent }}</td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
                <td colspan="8" class="text-center">No Record Found</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>
<script>
import { commonMixins } from "../mixins/commonMixins";

export default {
  name: "ContractCpiRateConfigTabView",
  data: () => ({
    role: "",
    loading: false,
    cpiData: [],
    cpiratesArr: [],
    foundRate: false,
    addRate: false,
    blockRemoval: true,
    permissions: [],
    canAddCpiRate: false,
  }),
  mixins: [commonMixins],
  watch: {
    cpiratesArr() {
      var self = this;
      self.blockRemoval = self.cpiratesArr.length <= 1;
    },
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == "add_cpi_rate") {
            self.canAddCpiRate = true;
          }
        }
      }
    },
  },
  created: function () {},
  mounted: function () {
    var self = this;
    var path = window.location.pathname;
    var pathArr = path.split("/");
    self.getPermissions();
    self.getCPIRates();
  },
  methods: {
    backCPiRateList() {
      var self = this;
      self.addRate = false;
      self.getCPIRates();
    },
    addLine($event, index) {
      var self = this;
      console.log(self.cpiratesArr);

      self.cpiratesArr[index].cpi_increase_error_msg = "";
      self.cpiratesArr[index].rate_increase_error_msg = "";
      self.cpiratesArr[index].limit_percent_error_msg = "";

      if (
        self.cpiratesArr[index].cpi_increase_percent != null &&
        self.cpiratesArr[index].cpi_increase_percent != "" &&
        self.cpiratesArr[index].rate_increase_percent != null &&
        self.cpiratesArr[index].rate_increase_percent != "" &&
        self.cpiratesArr[index].limit_percent != null &&
        self.cpiratesArr[index].limit_percent != ""
      ) {
        self.cpiratesArr.push({
          id: 0,
          cpi_increase_percent: null,
          rate_increase_percent: null,
          limit_percent: null,
          cpi_increase_error_msg: "",
          rate_increase_error_msg: "",
          limit_percent_error_msg: "",
        });
      } else {
        if (
          self.cpiratesArr[index].cpi_increase_percent == null ||
          self.cpiratesArr[index].cpi_increase_percent == ""
        ) {
          self.cpiratesArr[index].cpi_increase_error_msg =
            "CPI Percent Required.";
        }

        if (
          self.cpiratesArr[index].rate_increase_percent == null ||
          self.cpiratesArr[index].rate_increase_percent == ""
        ) {
          self.cpiratesArr[index].rate_increase_error_msg =
            "Rate Percent Required.";
        }

        if (
          self.cpiratesArr[index].limit_percent == null ||
          self.cpiratesArr[index].limit_percent == ""
        ) {
          self.cpiratesArr[index].limit_percent_error_msg =
            "Limit Percent Required.";
        }
      }
    },
    removeLine(lineId, id) {
      var self = this;
      if (id == 0) {
        if (!self.blockRemoval) self.cpiratesArr.splice(lineId, 1);
      } else {
        $.ajax({
          url: process.env.ROOT_API + "/contract/remove-contract-cpi-rate",
          type: "POST",
          data: { id: id },
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            if (data.status == "success") {
              self.cpiratesArr.splice(lineId, 1);
            }
          },
          error: function (jqXHR, exception) {},
        });
      }
    },
    getCPIRates() {
      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");
      self.loading = true;
      self.addRate = false;

      $.ajax({
        url: process.env.ROOT_API + "/contract/cpirate",
        type: "POST",
        data: { contract_id: segments[3], flag: "for_contract_update" },
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;

          if (data.status == "success") {
            self.loading = false;
            self.foundRate = data.content.foundRate;

            if (data.content.foundRate == true) {
              self.cpiData = data.content.cpiRates;
              self.cpiratesArr = data.content.cpiRates;
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, "contract-view-data");
        },
      });
    },
    createCPiRate() {
      var self = this;
      var error = false;
      var sectionArr = [];
      var path = window.location.pathname;
      var segments = path.split("/");
      var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

      for (var i = 0; i < self.cpiratesArr.length; i++) {
        self.cpiratesArr[i].section_error_msg = "";
        self.cpiratesArr[i].section_value_error_msg = "";
        self.cpiratesArr[i].cpi_increase_error_msg = "";
        self.cpiratesArr[i].rate_increase_error_msg = "";
        self.cpiratesArr[i].limit_percent_error_msg = "";

        if (
          self.cpiratesArr[i].cpi_increase_percent == null ||
          self.cpiratesArr[i].cpi_increase_percent == ""
        ) {
          self.cpiratesArr[i].cpi_increase_error_msg = "CPI Percent Required.";
          error = true;
        } else {
          if (!self.cpiratesArr[i].cpi_increase_percent.match(checkNumber)) {
            self.cpiratesArr[i].cpi_increase_error_msg =
              "CPI Percent is not valid.";
            error = true;
          }
        }
        if (
          self.cpiratesArr[i].rate_increase_percent == null ||
          self.cpiratesArr[i].rate_increase_percent == ""
        ) {
          self.cpiratesArr[i].rate_increase_error_msg =
            "Rate Percent Required.";
          error = true;
        } else {
          if (!self.cpiratesArr[i].rate_increase_percent.match(checkNumber)) {
            self.cpiratesArr[i].rate_increase_error_msg =
              "CPI Percent is not valid.";
            error = true;
          }
        }
        if (
          self.cpiratesArr[i].limit_percent == null ||
          self.cpiratesArr[i].limit_percent == ""
        ) {
          self.cpiratesArr[i].limit_percent_error_msg =
            "Limit Percent Required.";
          error = true;
        } else {
          if (!self.cpiratesArr[i].limit_percent.match(checkNumber)) {
            self.cpiratesArr[i].limit_percent_error_msg =
              "Limit Percent is not valid.";
            error = true;
          }
        }
      }
      // alert(error);
      if (error == false) {
        var cpiArr = [];
        var rateArr = [];
        var limitArr = [];
        var conAssRateIdArr = [];

        for (var i = 0; i < self.cpiratesArr.length; i++) {
          conAssRateIdArr.push(self.cpiratesArr[i].id);
          rateArr.push(self.cpiratesArr[i].rate_increase_percent);
          cpiArr.push(self.cpiratesArr[i].cpi_increase_percent);
          limitArr.push(self.cpiratesArr[i].limit_percent);
        }

        var fields = {
          contract_id: segments[3],
          rate: rateArr,
          cpi: cpiArr,
          limit: limitArr,
          cnt_ast_rt_id: conAssRateIdArr,
        };
        self.loading = true;

        $.ajax({
          url: process.env.ROOT_API + "/contract/cpirate/create",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status == "success") {
              self.getCPIRates();
            } else {
              if (data.content.length > 0) {
                var err = "<ul>";
                $(".alert-contract").empty();

                for (var i = 0; i < data.content.length; i++) {
                  err += "<li>" + data.content[i] + "</li>";
                }
                err += "</ul>";
                $(".alert-contract").append(err);
                $(".alert-contract").addClass("show");
              }
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(
              jqXHR,
              true,
              "contract-cpi-rate-create"
            );
          },
        });
      }
    },
    loadContractCPiRate(flag) {
      var self = this;
      self.addRate = true;
      if (flag == "create") {
        self.cpiratesArr = [];
        self.cpiratesArr.push({
          id: 0,
          cpi_increase_percent: null,
          rate_increase_percent: null,
          limit_percent: null,
          cpi_increase_error_msg: "",
          rate_increase_error_msg: "",
          limit_percent_error_msg: "",
        });
      } else {
      }
    },
  },
};
</script>

<style scope>
#contact_table thead tr th {
  text-align: center;
  background: #9badc1 !important;
  color: #fff !important;
  font-family: "SanFranciscoDisplayRegular";
  padding: 12px 15px;
  font-weight: normal !important;
  font-size: 15px !important;
  line-height: 16px !important;
}
.no-data-found {
  text-align: center;
}
#contact_table tr td,
.reservation-list-unsynced > tr td {
  color: #444444 !important;
  font-family: "SanFranciscoDisplayRegular";
  word-break: break-all;
  word-break: break-word;
  padding: 10px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractCpiRateConfigTabView.vue